module.exports = __webpack_public_path__ + "img/no-card.fa3a795e.png";